import { TopbarWalletDropdown, TopbarWalletDropdownProps } from './TopbarWalletDropdown'
import { Button } from '@/ui/atoms/button/Button'

export interface TopbarWalletProps {
  connectedWalletInfo?: TopbarWalletDropdownProps
  onConnect: () => void
}

export function TopbarWallet({ connectedWalletInfo, onConnect }: TopbarWalletProps) {
  return (
    <div className="sm:w-44 md:w-24 lg:w-44">
      {connectedWalletInfo ? (
        <TopbarWalletDropdown {...connectedWalletInfo} />
      ) : (
        <Button size="m" variant="primary" className="w-full px-3" onClick={onConnect}>
          <span>
            Connect <span className="hidden sm:inline md:hidden lg:inline">Wallet</span>
          </span>
        </Button>
      )}
    </div>
  )
}

TopbarWallet.displayName = 'TopbarWallet'
